// extracted by mini-css-extract-plugin
export default {"tag":"filter_tag__tag--YWVu","icon":"filter_tag__icon--ivcn"};